import { useState } from 'react';

const useNotesDialog = () => {
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [noteValue, setNoteValue] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [isEditing, setIsEditing] = useState(true);

  const showNoteDialog = (row, editable = true) => {
    setSelectedRow(row);
    setNoteValue(row?.notes || '');
    setIsEditing(editable);
    setNoteDialogOpen(true);
  };

  const resetDialog = () => {
    setNoteDialogOpen(false);
    setNoteValue('');
    setSelectedRow(null);
    setIsEditing(true);
  };

  return {
    noteDialogOpen,
    noteValue,
    setNoteValue,
    selectedRow,
    isEditing,
    showNoteDialog,
    resetDialog,
    setIsEditing,
  };
};

export default useNotesDialog;
